// extracted by mini-css-extract-plugin
export default {"root":"TableHeadTip_root__gAQI8","content":"TableHeadTip_content__FUQ3Q","percent":"TableHeadTip_percent__pddr3"};